import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Productlifecycle(props) {
    return (
        <div>
            <Container className="h-100 tekrevol_dark_bg p-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Your Strategy">
                            <h2>Rethink Your Business Strategy Through Digital Transformation Solutions</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                        <p>Businesses have to be the first to accept change. Those who don’t follow the path often get
                            left behind. Our digital transformation solutions are for those ready to take on the digital
                            challenge.</p>
                        <p> TekRevol specializes in helping businesses transform themselves digitally by rethinking,
                            evaluating, and updating their business strategies and shaping them according to modern-day
                            requirements.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Productlifecycle;